/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Modal, DatePicker, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import ContituentSelect from '../../../components/Custom/ConstituentSelect'
import ConstituentDetails from '../details'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedConstituent: null,
			didSelectConstituent: false,
			selectedOfficer: null,
			didSelectOfficer: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		const { officialReceipt, form } = this.props
		if (officialReceipt) {
			const { setFieldsValue } = form

			setFieldsValue({
				constituent_uid: officialReceipt.constituent_uid
			})
			this.setState({ selectedConstituent: { uid: officialReceipt.constituent_uid, name: officialReceipt.name, didSelectConstituent: false } })
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { selectedConstituent } = this.state
		const { form, AuthStore, saveOfficialReceipt, onClose, officialReceipt } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const request_date = moment(values.request_date).format('YYYY-MM-DD HH:mm:ss')
			const or_issued_date = moment(values.or_issued_date).format('YYYY-MM-DD HH:mm:ss')
			let params = Object.assign({}, values, {
				barangay_uid,
				name: (!selectedConstituent.didSelectConstituent) ? selectedConstituent.name : `${selectedConstituent.first_name} ${selectedConstituent.middle_name || ''} ${selectedConstituent.last_name}`,
				constituent_uid: selectedConstituent.uid,
				request_date,
				or_issued_date
			})
			if (officialReceipt) {
				params = Object.assign({}, params, { or_uid: officialReceipt.uid })
			}
			// console.log('params', params)

			message.loading({ key: 'set_or', content: 'Saving Official Receipt, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveOfficialReceipt(params).then((response) => {
					// const { file_url } = response.data.setCertificateCommunityTax
					// window.open(`${process.env.REACT_APP_BACKEND_API}${file_url}`, '_blank')
					this.setState({ isSaving: false })
					message.success({ key: 'set_or', content: 'Official Receipt successfully saved.' })

					if (officialReceipt) {
						//update audit trail
						const auditParams = {
							module_name: 'Official Receipt',
							action: 'Update',
							message: `Update OR ${officialReceipt.or_number}`
						}
						AuthStore.saveAuditTrail(auditParams)
					} else {
						//create audit trail
						const auditParams = {
							module_name: 'Official Receipt',
							action: 'Create',
							message: 'Add new official receipt'
						}
						AuthStore.saveAuditTrail(auditParams)
					}

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error generating official receipt')
					message.error({ key: 'set_or', content: err.message.replace('GraphQL error:', '') })
					// resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, AuthStore, officialReceipt } = this.props
		const { getFieldDecorator, getFieldValue } = form
		const { barangay_uid } = AuthStore
		const { selectedConstituent, isSaving } = this.state
		
		return (
			<Modal
				title="Official Receipts"
				// placement="right"
				// closable={!isSaving}
				// onClose={onClose}
				visible={visible}
				width={'70%'}
				// bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
				okText='Save'
				maskClosable={!isSaving}
				onCancel={onClose}
				onOk={this.handleSubmit}
				confirmLoading={isSaving}
			>
				<Form onSubmit={this.handleSubmit}>
					{
						selectedConstituent &&
						<ConstituentDetails selectedConstituent={selectedConstituent} table_name={null} />
					}
					<Row gutter={16}>
						<Col md={8} sm={24}>
							<Form.Item label='Constituent'>
								{ getFieldDecorator('constituent_uid', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<ContituentSelect 
										barangay_uid={barangay_uid}
										placeholder='Select Constituent Name'
										onSelectedItem={(item) => {
											if (item) {
												this.setState({ selectedConstituent: Object.assign({}, item, { didSelectConstituent: true }) })
											} else {
												this.setState({ selectedConstituent: null })
											}
										}}
									/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='OR Number'>
								{ getFieldDecorator('or_number', {
									initialValue: officialReceipt ? officialReceipt.or_number : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input type='number' min={0} placeholder='Enter OR number' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Amount'>
								{ getFieldDecorator('amount', {
									initialValue: officialReceipt ? officialReceipt.amount : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input type='number' min={0} placeholder='Enter Amount' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Type'>
								{ getFieldDecorator('transaction_type', {
									initialValue: officialReceipt ? officialReceipt.transaction_type : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Transaction Type'>
										<Select.Option value='Barangay Clearance'>Barangay Clearance</Select.Option>
										<Select.Option value='Barangay Business Clearance'>Barangay Business Clearance</Select.Option>
										<Select.Option value='Barangay Certification'>Barangay Certification</Select.Option>
										<Select.Option value='Others'>Others</Select.Option>
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							_.isEqual(getFieldValue('transaction_type'), 'Others') &&
							<Col md={8} sm={24}>
								<Form.Item label='Other specify'>
									{ getFieldDecorator('other_specify', {
										initialValue: officialReceipt ? officialReceipt.other_specify : null,
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Enter Other Transaction Type' />
									)}
								</Form.Item>
							</Col>
						}
						<Col md={8} sm={24}>
							<Form.Item label='Request Date'>
								{ getFieldDecorator('request_date', {
									initialValue: (officialReceipt && moment(officialReceipt.request_date).isValid()) ? 
										moment(officialReceipt.request_date) : moment(),
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Issued Date'>
								{ getFieldDecorator('or_issued_date', {
									initialValue: (officialReceipt && moment(officialReceipt.or_issued_date).isValid()) ? 
										moment(officialReceipt.or_issued_date) : moment(),
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>
		)
	}
}

const SET_OR = gql`
    mutation setOfficialReceipt($input: JSON) {
		setOfficialReceipt(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-generate-certificate' }),
	inject('AuthStore'),
	graphql(SET_OR, {
		props({ mutate }) {
			return {
				saveOfficialReceipt(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['officialReceipts']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
